import { useContext } from 'react';
import { CreateTermineFormContext } from './CreateTermineFormContext';

export function useCreateTermineFormContext() {
  const context = useContext(CreateTermineFormContext);
  if (!context) {
    throw new Error(
      'useCreateTermineFormContext must be used within CreateTermineFormProvider',
    );
  }
  return context;
}
